import * as types from "../mutation-types";
import isEqual from "lodash.isequal";

function initialState() {
    return {
        hypoId: "",
        hypoName: "Untitled",
        hypoType: "1",
        allocateBy: 0,
        currency: "USD",
        timePeriod: 1,
        rawHypoInput: null,
        lastCompletedStep: null,
        sourceChosen: null,
        flowMap: null,
        assetAllocation: [],
        firmSaved: false
    };
}
const state = {
    ...initialState()
};

const mutations = {
    [types.SET_HYPO_FLOW_MAP](state, data) {
        state.flowMap = data;
    },
    [types.SET_HYPO_ID](state, data) {
        state.hypoId = data;
    },
    [types.SET_HYPO_NAME](state, data) {
        state.hypoName = data;
    },
    [types.SET_HYPO_TYPE](state, data) {
        state.hypoType = data;
    },
    [types.SET_HYPO_LAST_COMPLETED_STEP](state, data) {
        state.lastCompletedStep = data;
    },
    [types.SET_HYPO_CHOSEN_SOURCE](state, data) {
        state.sourceChosen = data;
    },
    [types.SET_CURRENCY](state, data) {
        state.currency = data;
    },
    [types.SET_TIME_PERIOD](state, data) {
        state.timePeriod = data;
    },
    [types.SET_ALLOCATE_BY](state, data) {
        state.allocateBy = data;
    },
    [types.SET_ASSET_ALLOCATION](state, data) {
        state.assetAllocation = data;
    },
    [types.SET_RAW_HYPO_INPUT](state, data) {
        state.rawHypoInput = data;
    },
    [types.RESET](state) {
        const initialData = initialState();
        Object.keys(initialData).forEach(key => {
            state[key] = initialData[key];
        });
    },
    [types.SET_FIRM_SAVED](state, data) {
        state.firmSaved = data;
    }
};

const getters = {
    hasUnsavedChanges(state, getters, rootState, rootGetters) {
        const rawHypoInput = state.rawHypoInput;
        const currentHypoInput = rootGetters.hypoInput;
        if (rootState.auth.isTokenExpired) {
            return false;
        }
        return !isEqual(rawHypoInput, currentHypoInput) && rootGetters["investments/hasPortfolio"];
    },
    getType(state) {
        return state.hypoType;
    },
    getName() {
        return state.hypoName;
    },
    // Hypo level currency is for getting chart data and generate report. (Now there is no UI and design for changing hypo level currency)
    hypoCurrencySymbol(state, getters, rootState, rootGetters) {
        const currency = rootGetters["config/currencyList"].find(i => i.currencyId === state.currency);
        return (currency && currency.currencySymbol) || "";
    },
    getPCTAssetAllocation(state) {
        const broadAssetClass = state.assetAllocation && state.assetAllocation.find(i => i.groupType === 0);
        if (!broadAssetClass) {
            return {};
        }
        // pct asset allocation chart type: 0:B,1:P,2:S
        const pctChartTypeMapping = {
            0: "B",
            1: "P",
            2: "S"
        };
        const { groupId, chartType, groupName, compItems } = broadAssetClass;
        const pctChartType = pctChartTypeMapping[chartType];
        const pctCompItems = Object.keys(compItems)
            .sort((aClassId, bClassId) => {
                return compItems[aClassId].order - compItems[bClassId].order;
            })
            .map(assetClassId => {
                const { className, color, borderColor, mappingIndex } = compItems[assetClassId];
                return {
                    ItemName: className,
                    ClassId: assetClassId,
                    Color: color,
                    BorderColor: borderColor,
                    Index: mappingIndex
                };
            });
        return {
            TP: groupId,
            Chart: pctChartType,
            Name: groupName,
            CompItem: pctCompItems
        };
    }
};

const actions = {
    updateStateByPreference({ state, commit, rootState }) {
        const { preference, config } = rootState;
        commit(types.SET_ALLOCATE_BY, preference.allocateBy);
        commit(types.SET_CURRENCY, preference.currency);
        commit(types.SET_TIME_PERIOD, preference.timePeriod);
        commit(types.SET_ASSET_ALLOCATION, config.assetAllocation);
    },
    renameHypo({ state, commit, dispatch }) {
        const { hypoName } = state;
        commit(`hypo/${types.SET_HYPO_NAME}`, hypoName);
        return dispatch("saveInitialHypoData", null, { root: true });
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
